import { useEffect, useState } from 'react';

import { ScrollLock } from '@common/utils';

export const useScrollLock = (open: boolean) => {
  const [containerRef, setContainerRef] = useState<HTMLDivElement | null>(null);
  const [is_container_visible, setIsContainerVisible] = useState(false);
  const [is_drawer_visible, setIsDrawerVisible] = useState(false);

  const handleTransitionEnd = () => {
    if (!open) {
      setIsContainerVisible(false);
    }
  };

  useEffect(() => {
    if (!containerRef) {
      return;
    }
    const bodyLock = new ScrollLock(containerRef);

    if (open) {
      bodyLock.disableScroll();
      setIsContainerVisible(true);
      setIsDrawerVisible(true);
    } else {
      bodyLock.enableScroll();
      setIsDrawerVisible(false);
    }
    return () => {
      bodyLock.enableScroll();
    };
  }, [open, containerRef]);

  return { setContainerRef, handleTransitionEnd, is_container_visible, is_drawer_visible };
};
